/** After-sales vocabulary: mirror of backend `app/core/constants/after_sales.py`.
 *  Generated once from the backend constants; `tests/core/test_service_desk_mirror.py` keeps the two equal. */

export const ASSET_STATUS_VALUES = ["active", "under_repair", "decommissioned", "returned"] as const;
export type AssetStatus = (typeof ASSET_STATUS_VALUES)[number];

export const WARRANTY_START_BASIS_VALUES = ["acceptance", "installation", "delivery", "manual"] as const;
export type WarrantyStartBasis = (typeof WARRANTY_START_BASIS_VALUES)[number];

export const WARRANTY_STATUS_VALUES = ["in_warranty", "expiring", "expired", "unknown"] as const;
export type WarrantyStatus = (typeof WARRANTY_STATUS_VALUES)[number];

export const WARRANTY_DECISION_VALUES = ["covered", "partially_covered", "not_covered", "pending_manufacturer"] as const;
export type WarrantyDecision = (typeof WARRANTY_DECISION_VALUES)[number];

export const WARRANTY_COVER_VALUES = ["parts", "labor", "travel"] as const;
export type WarrantyCover = (typeof WARRANTY_COVER_VALUES)[number];

export const CONTRACT_STATUS_VALUES = ["draft", "active", "expired", "cancelled"] as const;
export type ContractStatus = (typeof CONTRACT_STATUS_VALUES)[number];

export const ENTITLEMENT_KIND_VALUES = ["pm_visits", "calibrations", "onsite_visits", "remote_support_hours", "ticket_allowance"] as const;
export type EntitlementKind = (typeof ENTITLEMENT_KIND_VALUES)[number];

export const ENTITLEMENT_PERIOD_VALUES = ["contract", "year", "month"] as const;
export type EntitlementPeriod = (typeof ENTITLEMENT_PERIOD_VALUES)[number];

export const PLAN_KIND_VALUES = ["pm", "calibration"] as const;
export type PlanKind = (typeof PLAN_KIND_VALUES)[number];

export const PLAN_AUTO_CREATE_VALUES = ["off", "ticket", "ticket_and_propose_slots"] as const;
export type PlanAutoCreate = (typeof PLAN_AUTO_CREATE_VALUES)[number];

export const PLAN_ANCHOR_VALUES = ["completion", "schedule"] as const;
export type PlanAnchor = (typeof PLAN_ANCHOR_VALUES)[number];

export const VISIT_KIND_VALUES = ["corrective", "pm", "calibration", "installation", "inspection", "training"] as const;
export type VisitKind = (typeof VISIT_KIND_VALUES)[number];

export const VISIT_STATUS_VALUES = ["proposed", "scheduled", "dispatched", "on_site", "completed", "cannot_complete", "cancelled", "no_access"] as const;
export type VisitStatus = (typeof VISIT_STATUS_VALUES)[number];

export const CHECKLIST_RESULT_VALUES = ["pass", "fail", "na"] as const;
export type ChecklistResult = (typeof CHECKLIST_RESULT_VALUES)[number];

export const RMA_STATUS_VALUES = ["requested", "approved", "awaiting_return", "received", "inspected", "credited", "replaced", "repaired", "rejected", "closed"] as const;
export type RmaStatus = (typeof RMA_STATUS_VALUES)[number];

export const RMA_DIRECTION_VALUES = ["from_customer", "to_supplier"] as const;
export type RmaDirection = (typeof RMA_DIRECTION_VALUES)[number];

export const RMA_RESOLUTION_VALUES = ["repair", "replace", "credit"] as const;
export type RmaResolution = (typeof RMA_RESOLUTION_VALUES)[number];

export const PROJECT_STATUS_VALUES = ["planned", "in_progress", "punch_list", "ready_for_acceptance", "handed_over", "on_hold", "cancelled"] as const;
export type ProjectStatus = (typeof PROJECT_STATUS_VALUES)[number];

export const STAGE_STATUS_VALUES = ["pending", "in_progress", "passed", "failed"] as const;
export type StageStatus = (typeof STAGE_STATUS_VALUES)[number];

export const PUNCH_STATUS_VALUES = ["open", "in_progress", "fixed", "verified", "reopened", "waived"] as const;
export type PunchStatus = (typeof PUNCH_STATUS_VALUES)[number];

export const PUNCH_DONE_STATUSES = ["verified", "waived"] as const;

export const PART_COVERAGE_VALUES = ["warranty", "contract", "chargeable"] as const;
export type PartCoverage = (typeof PART_COVERAGE_VALUES)[number];

export const SPARE_REQUEST_STATUS_VALUES = ["requested", "picked", "issued"] as const;
export type SpareRequestStatus = (typeof SPARE_REQUEST_STATUS_VALUES)[number];

export const TIME_ACTIVITY_VALUES = ["remote", "travel", "on_site", "admin"] as const;
export type TimeActivity = (typeof TIME_ACTIVITY_VALUES)[number];

export const ASSET_EVENT_KIND_VALUES = [
  "installed",
  "accepted",
  "ticket_opened",
  "ticket_resolved",
  "visit",
  "part_replaced",
  "calibration_done",
  "pm_done",
  "moved_site",
  "warranty_extended",
  "status_changed",
  "created",
  "updated",
  "moved_organisation",
  "archived",
  "restored",
  "document_added",
] as const;
export type AssetEventKind = (typeof ASSET_EVENT_KIND_VALUES)[number];

export const ASSET_TAG_PREFIX = "AST-" as const;

export const CONTRACT_NO_PREFIX = "CTR-" as const;

export const PROJECT_NO_PREFIX = "INS-" as const;

export const VISIT_NO_PREFIX = "VIS-" as const;

export const RMA_NO_PREFIX = "RMA-" as const;

export const WARRANTY_EXPIRING_DAYS_DEFAULT = 60 as const;

export const CONTRACT_RENEWAL_REMINDER_DAYS_DEFAULT = 60 as const;

export const RMA_RETURN_WINDOW_DAYS_DEFAULT = 30 as const;

export const VISIT_PROPOSED_WINDOWS_MAX = 3 as const;

export const VISIT_RESCHEDULE_MIN_HOURS = 24 as const;

export const VISIT_SLOT_LOOKAHEAD_BUSINESS_DAYS = 10 as const;

export const ASSET_MATCH_CHOICES_MAX = 6 as const;

export const QR_LABELS_PER_SHEET = 24 as const;

export const ASSET_DOCUMENT_KIND_VALUES = ["manual", "warranty_card", "certificate", "report", "photo", "other"] as const;
export type AssetDocumentKind = (typeof ASSET_DOCUMENT_KIND_VALUES)[number];

export const ASSET_ACTOR_TYPE_VALUES = ["staff", "contact", "system", "connector", "import"] as const;
export type AssetActorType = (typeof ASSET_ACTOR_TYPE_VALUES)[number];

export const ASSET_TAG_DIGITS = 4 as const;

export const ASSET_SERIAL_MAX = 120 as const;

export const ASSET_NAME_MAX = 200 as const;

export const ASSET_TEXT_MAX = 120 as const;

export const ASSET_LOCATION_MAX = 200 as const;

export const ASSET_NOTES_MAX = 2000 as const;

export const ASSET_DOCUMENT_TITLE_MAX = 160 as const;

export const ASSET_EVENT_NOTE_MAX = 500 as const;

export const ASSET_TAGS_MAX = 20 as const;

export const ASSET_EXTERNAL_IDS_MAX = 10 as const;

export const ASSET_EVENTS_PAGE_MAX = 100 as const;

export const ASSET_PAGE_DEFAULT = 50 as const;

export const WARRANTY_EXPIRING_DAYS_RANGE = [1, 365] as const;

export const WARRANTY_PERIOD_MONTHS_MAX = 240 as const;

export const PORTAL_ASSET_PATH = "/equipment/{token}" as const;

export const QR_TOKEN_LENGTH = 10 as const;

// Public alphabet for QR tags (no look-alike characters); not a credential.
export const QR_TOKEN_ALPHABET = "abcdefghjkmnpqrstuvwxyz23456789" as const; // gitleaks:allow

export const QR_LABEL_COLUMNS = 3 as const;

export const QR_LABEL_ROWS = 8 as const;

export const QR_LABEL_ASSETS_MAX = 240 as const;

export const PART_DESCRIPTION_MAX = 300 as const;

export const PART_QUANTITY_MAX = 9999 as const;

export const PART_SERIAL_MAX = 120 as const;

export const PART_SKU_MAX = 120 as const;

export const PARTS_PAGE_MAX = 200 as const;

export const ASSET_LOOKUP_QUERY_MAX = 120 as const;

export const ASSET_LOOKUP_QUERY_MIN = 2 as const;

export const SITE_NAME_MAX = 160 as const;

export const SITE_REGION_MAX = 120 as const;

export const SITE_PERSON_MAX = 160 as const;

export const SITE_ACCESS_NOTES_MAX = 500 as const;

export const CONTRACT_KIND_VALUES = ["service", "maintenance", "support", "warranty_extension"] as const;
export type ContractKind = (typeof CONTRACT_KIND_VALUES)[number];

export const CONSUMPTION_OVERRIDE_ACTION_VALUES = ["count_anyway", "waive"] as const;
export type ConsumptionOverrideAction = (typeof CONSUMPTION_OVERRIDE_ACTION_VALUES)[number];

export const MAINTENANCE_INTERVAL_KIND_VALUES = ["time", "meter"] as const;
export type MaintenanceIntervalKind = (typeof MAINTENANCE_INTERVAL_KIND_VALUES)[number];
